import React from "react";

var ta = require('time-ago/timeago') // node.js

const DateCell = (rowData) => {
  let d = new Date(rowData.last_seen_at * 1000);
  let formatedDate2 = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
    -2
  )}-${("0" + d.getDate()).slice(-2)} ${("0" + d.getHours()).slice(-2)}:${(
    "0" + d.getMinutes()
  ).slice(-2)}:${("0" + d.getSeconds()).slice(-2)}`;
  return (
    <React.Fragment>
    <span className="p-column-title">Last Seen At</span>    
      <span>{formatedDate2}</span><br/>
      <span>{ta.ago(d)}</span>
    </React.Fragment>
  );
};

export default DateCell;
